
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import VerticalTabs from 'components/VerticalTabs'
import {connect} from 'react-redux'
import MappedView from './MappedView'
import UnMappedView from './UnMappedView'

const tabs = [
  {
    key: 'unmapped',
    label: 'Unmapped',
    component: UnMappedView,
    to: `/settings/referrer-mapping/unmapped`
  },
  {
    key: 'mapped',
    label: 'Mapped',
    component: MappedView,
    to: `/settings/referrer-mapping/mapped`
  }
]

export class SettingReferrerMappingView extends React.Component {
  static propTypes = {
    type: PropTypes.string
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  render() {
    const {type} = this.props
    const Component = tabs.find(item => item.key === type).component

    return (
      <div className='settings-referrer-mapping-view container'>
        <div className='settings-referrer-mapping-view_menu'>
          <VerticalTabs items={tabs} activeItemId={type} />
        </div>
        <div className='settings-referrer-mapping-view_mappings'>
          <Component key={type} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, {params: {type}}) => ({
  type
})

export default connect(mapStateToProps, {})(SettingReferrerMappingView)



// WEBPACK FOOTER //
// ./client/views/SettingsReferrerMappingView/index.js